import qs from 'qs';

import { strapiBlockPopulates } from '../../@api/Strapi';

export const generateDepartmentDetailQuery = (slug: string): string => {
    const filters = {
        slug: {
            $eq: slug,
        },
    };

    const populate = {
        image: { populate: '*' },
        elements: strapiBlockPopulates,
        seo: { populate: '*' },
    };

    return qs.stringify({
        filters,
        populate,
    }, {
        encodeValuesOnly: true,
    });
};
